import { requestResponse } from './rsocketutils/rsocket.service'
import { requestStream } from './rsocketutils/rsocket.service';
import getscreenrequest from '@/model/requests/getscreenrequest';
import clientconfig from './service.utils';
import { NODE_CONTROL, requestResponseMQTT, requestStreamMQTT } from './mqttutils/mqttservice';


class ScreenService {

  getScreen(request: getscreenrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request, NODE_CONTROL.COMMANDS.TAG_SCREEN, responseCallback, errorCallback)
    }
    else {
      requestResponse(request, 'screens/get', responseCallback, errorCallback);
    }
  }
  getScreenToSave(request: getscreenrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request, 'screens/save', responseCallback, errorCallback)
    }
    else {
      requestResponse(request, 'screens/save', responseCallback, errorCallback);
    }
  }
  deleteScreen(request: getscreenrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request, 'screens/delete', responseCallback, errorCallback)
    }
    else {
      requestResponse(request, 'screens/delete', responseCallback, errorCallback);
    }
  }
  getAllScreensInfo(token: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestStreamMQTT("screens/info", "", completeCallback)
    }
    else {
      requestStream({

      }, "screens/info/" + token, completeCallback, errorCallback);
    }
  }

}

export default new ScreenService;